// extracted by css-extract-rspack-plugin
export default {"menuItem":"hmUev","dangerItem":"nw9m_"};